module.exports = __webpack_public_path__ + "static/media/munch17.ceb98fb8.wav";